import { useTranslation } from 'react-i18next';
import { Col, Row, Card } from 'antd';
import { BlockHeader } from '../../BlockHeader';
import useNumberFormatter from '../../../../hooks/format/useNumberFormatter';
import React from 'react';
import { ReactComponent as TaxesVmiIcon } from 'assets/img/icons/cardIcons/taxesVmi.svg';
import ProfTable from '../../ProfTable';

const VmiPaidTaxes = ({ tableData = [] }) => {
  const { t } = useTranslation();
  const formatCurrency = useNumberFormatter();

  const createSingleRowData = tableData => {
    return tableData.reduce((acc, item) => {
      acc[item.year] = item.amount ?? 0;
      return acc;
    }, {});
  };

  // Apply the transformation
  const singleRowData = createSingleRowData(tableData);

  const columns = [
    ...tableData.map(item => ({
      title:
        item.startMonth && item.endMonth
          ? `${item.year} (${item.startMonth} - ${item.endMonth} ${t('global.month')})`
          : item.year,
      dataIndex: item.year,
      key: item.year,
      render: value => (value !== undefined ? formatCurrency(value) : '-'),
    })),
  ];

  return (
    <>
      <Card className="card-simple card-simple-padding-none space-vertical-sm has-shadow" style={{ width: '100%' }}>
        <Row justify="start" align="middle">
          <Col>
            <BlockHeader
              icon={<TaxesVmiIcon className="icon--gray" />}
              title={t('professionalReport.basicData.vmiPaidTaxes.title')}
            />
          </Col>
        </Row>
        {tableData.length ? (
          <Row>
            <Col span={24}>
              <ProfTable
                rowKey={record => record.year}
                bordered
                dataSource={[singleRowData]}
                columns={columns}
                scroll={{ x: 'max-content' }}
                pagination={false}
              />
            </Col>
          </Row>
        ) : (
          <Card className="card-transparent space-vertical-sm">
            {t('professionalReport.basicData.vmiPaidTaxes.noInformation')}
          </Card>
        )}
      </Card>
    </>
  );
};

export default VmiPaidTaxes;
